import { GraphQLError } from "graphql";
import { AxiosError } from "axios";

export const parseGraphQLError = (e: GraphQLError) => {
  return {
    errorMessage: e.extensions.lokaliseKey || e.message,
    errorName: e.extensions.name || "no error name",
    code: e.extensions.code,
    message: e.message,
  };
};

export const parseAxiosError = (e: AxiosError) => {
  const responseData = e.response?.data as any;

  const errorMessage =
    responseData?.lokaliseKey ||
    responseData?.message ||
    e.message ||
    "Unknown error";

  const message =
    typeof responseData === "object" &&
    responseData &&
    "message" in responseData
      ? responseData.message
      : e.message;

  return {
    errorMessage,
    errorName: responseData?.name || "no error name",
    code: e.response?.status || responseData?.code || "no code",
    message: message,
  };
};
